import React from 'react';

import { Box, Typography } from 'vindi-ds-components';

import templates from './templates.json';
import AdvertsInfo from './adverts_info';
import styles from './styles';

function renderAdvertsInfos() {
  return (
    <>
      <AdvertsInfo title={templates.title[0]}>
        Para pagamentos à vista, parcelado ou por assinatura
      </AdvertsInfo>
      <AdvertsInfo title={templates.title[1]}>
        Com as retentativas inteligentes aumentamos sua conversão de venda de forma automática
      </AdvertsInfo>
      <AdvertsInfo title={templates.title[2]}>
        Receba, antecipe e controle todas as suas vendas pela Vindi
      </AdvertsInfo>
    </>
  );
}

function renderDetails() {
  return (
    <>
      <Box style={styles.headingBox}>
        <Typography variant='p' style={styles.paragraphDetails}>
          **As únicas taxas cobradas são sobre os métodos de pagamento,
          disponíveis na aba de preços do nosso site.
          Algumas funcionalidades adicionais estão disponíveis em planos mais avançados.&nbsp;
          <a href='https://vindi.com.br/precos/' target='_blank' rel='noreferrer' style={{ color: '#0421B4', marginInLine: '5px' }}>
            Consulte planos e preços aqui.
          </a>
        </Typography>
      </Box>
    </>
  );
}

function renderSubtitle() {
  return (
    <>
      <Box style={styles.paragraphBox}>
        <Typography variant='p'>
          Crie links de pagamentos em menos de 5 minutos e receba por Pix, Cartão, Boleto e
          BolePix (boleto com qr code), e envie de forma automática para seus clientes.
          Ao ativar sua conta, você terá acesso a:
        </Typography>
      </Box>
    </>
  );
}

function Adverts() {
  return (
    <Box style={styles.advertsBox}>
      <Box style={styles.headingBox}>
        <Typography variant='h5'>
          <strong style={styles.headingDetach}>
            Ative sua conta sem mensalidade&nbsp;
          </strong>
          e comece a vender em minutos!
        </Typography>
      </Box>
      {renderSubtitle()}
      {renderAdvertsInfos()}
      <Box style={styles.headingBox}>
        <Typography variant='p'>
          Ideal para negócios que estão começando, a Vindi é o parceiro de pagamentos
          que você precisa. Processe até R$ 10.000,00/mês em pagamentos, sem mensalidade!
        </Typography>
      </Box>
      {renderDetails()}
    </Box>
  );
}

export default Adverts;
